/* eslint-disable prefer-const */
/* eslint-disable indent */
/* eslint-disable no-unneeded-ternary */
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@material-ui/core/'
import apiAdmin from '../../../../../../../api/admin'
import './index.scss'

const Meetings = () => {
  const { user } = useSelector(({ session }) => session)
  const [meetings, setMeetings] = useState([])
  const [updateMeetings, setUpdateMeetings] = useState([])

  const getStatistics = () => {
    apiAdmin?.getStatisticsReviews(user?.accessKey)
      .then(({ data }) => setMeetings(data?.meetings))
  }

  useEffect(() => {
    getStatistics()
  }, [])

  useEffect(() => {
    if (meetings?.length) {
      let newArray = meetings?.map(i => {
        let reiting = []
        i?.users?.forEach(j => {
          reiting = [...reiting, { ...j, ...i.reviews?.find(k => k?.userUuid === j?.uuid) }]
        })
        return { ...i, reiting }
      })
      setUpdateMeetings(newArray)
    }
  }, [meetings])

  const searchOther = type => {
    if (type === null) {
      return '-'
    } else {
      switch (+type) {
        case 0:
          return 'We postponed the meeting'
        case 1:
          return 'My partner didn’t show up'
        case 2:
          return 'We hace decided to cancel it'
        case 3:
          return 'Other'
        default:
            return '-'
      }
    }
  }

  return (
    <Grid className='tableMeetings'>
      <Grid className='tableHeader'>
        <Grid className='headerName'>
          Meeting
        </Grid>
        <Grid className='headerEmail'>
          Email
        </Grid>
        <Grid className='headerMeetings'>
          Score
        </Grid>
        <Grid className='headerStories'>
          Feedback
        </Grid>
        <Grid className='headerCity'>
          Other
        </Grid>
      </Grid>
      {updateMeetings?.map(({ uuid, users, reviews, reiting }) => (
        <Grid className='tableBody' key={uuid}>
          <Grid className='bodyName'>
            ID: <span>{uuid}</span>
          </Grid>
          <Grid className='bodyEmail'>
            {reiting?.map(({ email }) => (
              <span key={email}>
                {email}
              </span>
            ))}
          </Grid>
          <Grid className='bodyMeetings'>
            {reiting?.map(({ rating }, index) => <span key={index}>{rating}</span>)}
          </Grid>
          <Grid className='bodyStories'>
            {reiting?.map(({ feedback }, index) => <span key={index}>{feedback ? feedback : '-'}</span>)}
          </Grid>
          <Grid className='bodyCity'>
            {reiting?.map(({ reason }, index) => <span key={index}>{searchOther(reason)}</span>)}
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Meetings
